import { request } from "../api/api";
import { multipartRequest } from "../api/api";


export const login = (data) => {
  return request.post("/user/logIn/", data);
};

export const signup = (data) => {
  return multipartRequest.post("/user/createAccount/", data);
};

export const forgotPassword = (data) => {
  return request.post("/user/forgotPassword/", data);
};

export const updatePassword = (data) => {
  return request.post("/user/updatePassword/", data);
};

export const changePassword = (id, data) => {
  return request.put(`/user/changePassword/${id}/`, data);
}
export const logout = (token) => {
  return request.post("/user/logOut/", token);
};


export const userPropfile = (id) => {
  return request.get(`/user/getUserProfileData/${id}`);
};

export const updateUserProfile = (id, data) => {

  return multipartRequest.put(`/user/updateUserProfile/${id}/`, data)
}



export const loginWithGoggle = (data) => {
  return request.post("/user/registerWithSocialMedia/", data)
}



/*************************Admin dashboard***********************/

export const getDataCollectorList = ({ currentPage, perPage } = {}) => {
  let queryParams = [];
  
  queryParams.push(`ordering=-id`);

  if (currentPage) queryParams.push(`page=${currentPage}`);
  if (perPage) queryParams.push(`page_size=${perPage}`);

  let queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

  return request.get(`/admin_panel/getDataCollectorList/${queryString}`);
};

export const getDataCollectorListDetails = (id) => {
  return request.get(`/admin_panel/getDataCollectorList/${id}`);
}

export const deactivateDataCollectorList = (id, data) => {
  return request.put(`admin_panel/updateDataCollectorState/${id}/`, data)
}

export const getRegionList = (searchParams, regionCurrentPage, perPage) => {
  let queryParams = [];
  // Add search only if it exists
  if (searchParams?.search) {
    queryParams.push(`search=${searchParams.search}`);
  }
  if (regionCurrentPage && perPage) {
    queryParams.push(`page=${regionCurrentPage}`);
    queryParams.push(`page_size=${perPage}`);
  }
  let queryString = `?${queryParams.join("&")}`;

  return request.get(`/admin_panel/region/${queryString}`);
};

export const addRegionList = (data) => {
  return request.post(`/admin_panel/region/`, data)
}

export const updateRegionList = (id, data) => {
  return request.put(`/admin_panel/region/${id}/`, data)
}

export const deleteRegionList = (id) => {
  return request.delete(`/admin_panel/region/${id}/`)
}

export const getStateList = (searchParams, stateCurrentPage, perPage) => {
  let queryParams = [];
  // Add search only if it exists
  if (searchParams?.search) {
    queryParams.push(`search=${searchParams.search}`);
  }
  if (stateCurrentPage, perPage) {
    queryParams.push(`page=${stateCurrentPage}`);
    queryParams.push(`page_size=${perPage}`);
  }

  let queryString = `?${queryParams.join("&")}`;

  return request.get(`/admin_panel/state/${queryString}`);
};

export const getStateDetails = (id) => {
  return request.get(`/admin_panel/state/?region_id=${id}`);
}
export const addStateList = (data) => {
  return request.post(`/admin_panel/state/`, data)
}

export const updateStateList = (id, data) => {
  return request.put(`/admin_panel/state/${id}/`, data)
}

export const deleteStateList = (id) => {
  return request.delete(`/admin_panel/state/${id}/`)
}

export const getLocalGovernmentList = (searchParams, localGovCurrentPage, perPage) => {
  let queryParams = [];
  // Add search only if it exists
  if (searchParams?.search) {
    queryParams.push(`search=${searchParams.search}`);
  }

  if (localGovCurrentPage && perPage) {
    queryParams.push(`page=${localGovCurrentPage}`);
    queryParams.push(`page_size=${perPage}`);
  }
  let queryString = `?${queryParams.join("&")}`;

  return request.get(`/admin_panel/localGovernment/${queryString}`);
};

export const getLocalGovernmentDetails = (data) => {
  return request.get(`/admin_panel/localGovernment/?region_id=${data.region_id}&state_id=${data.state_id}`);
}
export const addLocalGovernmentList = (data) => {
  return request.post(`/admin_panel/localGovernment/`, data)
}

export const updateLocalGovernmentList = (id, data) => {
  return request.put(`/admin_panel/localGovernment/${id}/`, data)
}

export const deleteLocalGovernmentList = (id) => {
  return request.delete(`/admin_panel/localGovernment/${id}/`)
}

export const getTaskAssignment = (data, currentPage, perPage) => {
  // Construct query parameters dynamically
  const queryParams = new URLSearchParams();

  if (data.data_collector__id) queryParams.append("data_collector__id", data.data_collector__id);
  if (data.status) queryParams.append("status", data.status);
  if (data.start_datetime) queryParams.append("start_datetime", data.start_datetime);
  if (data.end_datetime) queryParams.append("end_datetime", data.end_datetime);

  // Pagination parameters
  queryParams.append("page", currentPage);
  queryParams.append("per_page", perPage);

  // Make request with constructed query string
  return request.get(`/admin_panel/assignTaskToCollector?${queryParams.toString()}`);
};


export const addTaskAssignment = (data) => {
  return request.post(`/admin_panel/assignTaskToCollector/`, data);
}

export const getTaskAssignmentDetails = (id) => {
  return request.get(`/admin_panel/assignTaskToCollector/${id}/`)
}

/*************************Super admin dashboard***********************/

export const getTypeOfCrops = () => {
  return request.get("/superadmin_panel/getTypeOfCrops/");
};
export const crops = (id, page) => {
  return request.get(
    `/superadmin_panel/crops/?crops_type_id=${id}&page=${page}&page_size=${10}`
  );
};
export const addCrops = (params) => {
  return request.post("/superadmin_panel/crops/", params);
};
export const editCrops = (params, id) => {
  return request.put(`/superadmin_panel/crops/${id}/`, params);
};
export const deleteCrops = (id) => {
  return request.delete(`/superadmin_panel/crops/${id}/`);
};
export const getTypeOfLivestocks = () => {
  return request.get("/superadmin_panel/getTypeOfLivestock/");
};
export const livestocks = (id, page) => {
  return request.get(
    `/superadmin_panel/livestock/?livestock_type_id=${id}&page=${page}&page_size=${10}`
  );
};
export const addLiveStocks = (params) => {
  return request.post("/superadmin_panel/livestock/", params);
};
export const editLivestock = (params, id) => {
  return request.put(`/superadmin_panel/livestock/${id}/`, params);
};
export const deleteLivestock = (id) => {
  return request.delete(`/superadmin_panel/livestock/${id}/`);
};


export const getTypeOfPisciculture = () => {
  return request.get("/superadmin_panel/getTypeOfPisciculture/");
};
export const pisciculture = (id, page) => {
  return request.get(
    `/superadmin_panel/pisciculture/?pisciculture_type_id=${id}&page=${page}&page_size=${10}`
  );
};
export const addPisciculture = (params) => {
  return request.post("/superadmin_panel/pisciculture/", params);
};
export const editPisciculture = (params, id) => {
  return request.put(`/superadmin_panel/pisciculture/${id}/`, params);
};
export const deletePisciculture = (id) => {
  return request.delete(`/superadmin_panel/pisciculture/${id}/`);
};


export const getTypeOfTrainingProgram = () => {
  return request.get("/superadmin_panel/getTypeOfTrainingProgram/");
};
export const trainingProgram = (id, page) => {
  return request.get(
    `/superadmin_panel/trainingProgram/?training_program_type_id=${id}&page=${page}&page_size=${10}`
  );
};
export const addTrainingProgram = (params) => {
  return request.post("/superadmin_panel/trainingProgram/", params);
};
export const editTrainingProgram = (params, id) => {
  return request.put(`/superadmin_panel/trainingProgram/${id}/`, params);
};
export const deleteTrainingProgram = (id) => {
  return request.delete(`/superadmin_panel/trainingProgram/${id}/`);
};


export const trainingProgramSponsor = (page) => {
  return request.get(
    `/superadmin_panel/trainingProgramSponsor/?page=${page}&page_size=${10}`
  );
};
export const addTrainingProgramSponsor = (params) => {
  return request.post("/superadmin_panel/trainingProgramSponsor/", params);
};
export const editTrainingProgramSponsor = (params, id) => {
  return request.put(`/superadmin_panel/trainingProgramSponsor/${id}/`, params);
};
export const deleteTrainingProgramSponsor = (id) => {
  return request.delete(`/superadmin_panel/trainingProgramSponsor/${id}/`);
};


export const certificationAndTraining = (page) => {
  return request.get(
    `/superadmin_panel/certificationAndTraining/?page=${page}&page_size=${10}`
  );
};
export const addCertificationAndTraining = (params) => {
  return request.post("/superadmin_panel/certificationAndTraining/", params);
};
export const editCertificationAndTraining = (params, id) => {
  return request.put(`/superadmin_panel/certificationAndTraining/${id}/`, params);
};
export const deleteCertificationAndTraining = (id) => {
  return request.delete(`/superadmin_panel/certificationAndTraining/${id}/`);
};

export const getTypeOfMachinery = () => {
  return request.get("/superadmin_panel/getTypeOfMachinery/");
};
export const machinery = (id, page) => {
  return request.get(
    `/superadmin_panel/getTypeOfMachineryEquipment/?machinery_type_id=${id}&page=${page}&page_size=${10}`
  );
};
export const addMachineryEquipment = (params) => {
  return request.post("/superadmin_panel/getTypeOfMachineryEquipment/", params);
};
export const editMachineryEquipment = (params, id) => {
  return request.put(`/superadmin_panel/getTypeOfMachineryEquipment/${id}/`, params);
};
export const deleteMachineryEquipment = (id) => {
  return request.delete(`/superadmin_panel/getTypeOfMachineryEquipment/${id}/`);
};



